import Vue from "vue"

const STORAGE_KEY = "cookieConsent"

export const GRANTED = "granted"
export const DENIED = "denied"

function readStatus() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === GRANTED || stored === DENIED ? stored : null
  } catch (error) {
    // Brak dostępu do localStorage (tryb prywatny) — traktujemy jak brak decyzji.
    return null
  }
}

function writeStatus(status) {
  try {
    if (status === null) localStorage.removeItem(STORAGE_KEY)
    else localStorage.setItem(STORAGE_KEY, status)
  } catch (error) {
    // Zapis się nie udał — decyzja obowiązuje tylko do końca sesji.
  }
}

// status: "granted" | "denied" | null (jeszcze nie zdecydowano)
export const consent = Vue.observable({
  status: readStatus(),
})

export function isGranted() {
  return consent.status === GRANTED
}

export function isDecided() {
  return consent.status !== null
}

export function setStatus(status) {
  consent.status = status
  writeStatus(status)
}
